import { AxiosError } from "axios";
import { FormikErrors } from "formik";

const handleErrors = <Values,>(
  e: unknown,
  setErrors: (errors: FormikErrors<Values>) => void
) => {
  const axiosError = e as AxiosError<{ errors?: Record<string, string> }>;

  if (axiosError.response?.status === 400) {
    return handleBadParameter(axiosError.response.data?.errors ?? {}, setErrors);
  }
};

const handleBadParameter = <Values,>(
  errors: Record<string, string>,
  setErrors: (errors: FormikErrors<Values>) => void
) => {
  if (Object.keys(errors).length === 0) {
    return [];
  }

  // eslint-disable-next-line
  const formikErrors: any = {};

  Object.entries(errors).forEach(([key, value]) => {
    // Gérer les clés comme "stages[0].label"
    const arrayMatch = key.match(/^(\w+)\[(\d+)\]\.(\w+)$/);
    
    if (arrayMatch) {
      const [, arrayName, index, fieldName] = arrayMatch;
      const idx = parseInt(index);
      
      if (!formikErrors[arrayName]) {
        formikErrors[arrayName] = [];
      }
      
      if (!formikErrors[arrayName][idx]) {
        formikErrors[arrayName][idx] = {};
      }
      
      formikErrors[arrayName][idx][fieldName] = value;
    } else {
      // Clé simple comme "name"
      formikErrors[key] = value;
    }
  });

  setErrors(formikErrors as FormikErrors<Values>);
  return Object.entries(errors);
};

export { handleErrors };
